module.exports = __webpack_public_path__ + "img/alibaba-logos.97fbae9b.png";